<template>
    <div class="add-contact-container">
        <div class="section-wrapper">
            <div class="section-container">
                <label class="add-contact-label">Display Name</label>
                <div class="input-container">
                    <prime-input-text class="input-field" placeholder="John Doe" v-model="store.searchTerm" @keydown.enter="onEnter" @keydown="letterOnlyInputHandler" />
                </div>
            </div>
        </div>

        <div v-for="(email, index) in emailAdd" :key="index" class="section-wrapper">
            <div class="section-container">
                <label class="add-contact-label">
                    Email Address
                    <span v-if="index === 0" class="text-red-500 ml-1">*</span>
                </label>
                <div class="input-container">
                    <span class="pl-3 pr-2 text-gray-500">
                        <EnvelopeIcon class="h-5 w-5 text-gray-500" />
                    </span>
                    <prime-input-text
                        v-model="emailAdd[index]"
                        class="input-field !px-0"
                        placeholder="johndoe@email.com"
                        :class="{
                            'border-red-500': (index === 0 && !emailAdd[index]) ||
                                            (emailAdd[index] && emailAdd[index].trim() && !isValidEmail(emailAdd[index].trim()))
                        }"
                        required
                        @keydown.enter="onEnter"
                    />
                    <button v-if="emailAdd[index]" :disabled="emailAdd.length === 1" @click="removeEmail(index)" class="delete-item-btn">
                        <TrashIcon class="h-5 w-5 text-gray-500" />
                    </button>
                </div>
                <!-- Show validation message for first email only -->
                <div v-if="index === 0 && emailAdd[index] && emailAdd[index].trim()" class="validation-message">
                    <span v-if="isValidEmail(emailAdd[index].trim())" class="text-green-600 text-xs">
                        ✓ Valid email address
                    </span>
                    <span v-else class="text-red-500 text-xs">
                        ✗ Please enter a valid email address
                    </span>
                </div>
            </div>
        </div>

        <div v-if="emailAdd.length < 5" class="add-another-btn-container">
            <PlusIcon class="w-5 h-5 text-blue-600" />
            <p
                class="add-another-btn"
                :class="{ 'opacity-50 cursor-not-allowed': !canAddMoreEmail }"
                @click="canAddMoreEmail ? addEmail() : null"
            >
                Add Email
            </p>
        </div>

        <div v-for="(number, index) in phoneNumber" :key="index" class="section-wrapper">
            <div class="section-container">
                <label class="add-contact-label">Phone Number (Optional)</label>
                <div class="input-container">
                    <PrimeSelect
                        v-model="phoneNumber[index].country_code"
                        :options="visibleCountryOptions"
                        optionLabel="label"
                        optionValue="dial_code"
                        placeholder="US +1"
                        panelClass="country-select-panel"
                        class="whitespace-nowrap"
                        @show="onCountryDropdownShow"
                        @hide="onCountryDropdownHide"
                    >
                        <template #value="slotProps">
                            <div v-if="slotProps.value && slotProps.value.code" class="flex items-center">
                                <span>{{ slotProps.value.dial_code }}</span>
                            </div>
                            <span v-else>{{ slotProps.placeholder }}</span>
                        </template>

                        <template #option="slotProps">
                            <div class="flex items-center">
                                <img
                                    :src="`/flags/${slotProps.option.code}.svg`"
                                    class="mr-2"
                                    style="width: 18px"
                                    :alt="slotProps.option.name"
                                    loading="lazy"
                                />
                                <span>{{ slotProps.option.label }}</span>
                            </div>
                        </template>
                    </PrimeSelect>
                    <prime-input-text
                        v-model="phoneNumber[index].phone_number"
                        class="input-field w-full"
                        placeholder="555-555-5555"
                        type="number"
                    />
                    <button v-if="phoneNumber[index].phone_number" @click="removephoneNumber(index)" class="delete-item-btn">
                        <TrashIcon class="h-5 w-5 text-gray-500" />
                    </button>
                </div>
            </div>
        </div>

        <div v-if="phoneNumber.length < 5" class="add-another-btn-container">
            <PlusIcon class="w-5 h-5 text-blue-600" />
            <p
                class="add-another-btn"
                :class="{ 'opacity-50 cursor-not-allowed': !canAddMorePhone }"
                @click="canAddMorePhone ? addphoneNumber() : null"
            >
                Add Phone
            </p>
        </div>

        <!-- <div class="section-tag-container">
            <label class="add-contact-label">Tags</label>

            <div class="input-container px-3" @click="togglePopover">
                <prime-input-text
                    v-model="selectedTag"
                    class="input-field !px-0"
                    placeholder="Select or Add a Tag"
                    @keydown.enter="onTagInputEnter"
                />
                <PhCaretDown :size="20" class="cursor-pointer" />
                <PrimePopover ref="popover">
                    <div class="tags-container">
                        <div class="tag-items">
                            <div class="tag-input">
                                <span v-for="item in tags" :key="item.code" @click="() => handleTag(item)">
                                    {{ item.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                </PrimePopover>
            </div>


            <div class="flex gap-2 mt-0.5">
                <button class="custom-button" v-for="tag in selectedTags" :key="tag.name" @click="removeTag(tag)">
                    {{ tag.name }}

                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                            d="M9 3L3 9M3 3L9 9"
                            stroke="#A4A7AE"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div> -->
    </div>

    <!-- actions -->
    <div class="add-contact-footer">
        <div class="footer-actions">
            <prime-button @click="close" class="p-btn-root_secondary" label="Cancel" />

            <prime-button
                label="Add Contact"
                variant="primary"
                :disabled="!canAddContact"
                @click="addContact"
                @keyup.enter="addContact"
                :loading="isAddingContact"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import countries from '@/assets/json/countries.json';
import { EnvelopeIcon, TrashIcon } from '@heroicons/vue/24/outline';
import { PlusIcon } from '@heroicons/vue/24/solid';
import PrimeInputText from 'primevue/inputtext';
import { computed, onUnmounted, ref } from 'vue';
import { useContactsStore } from '~/stores/person/contacts';
import { useVaultStore } from '~/stores/person/vault/vault';

const { letterOnlyInputHandler } = useUtils();

// Define props
const props = defineProps<{
    modalData?: any;
}>();

//handle close dialog
const emit = defineEmits(['closeDialog']);

const close = () => {
    emit('closeDialog');
};

const countryOptions = countries.map((c) => ({
    label: `${c.name} (${c.dial_code})`,
    value: c,
    code: c.code.toLowerCase(),
    name: c.name,
    dial_code: c.dial_code,
}));
const PAGE_SIZE = 10;
const visibleCountryOptions = ref(countryOptions.slice(0, PAGE_SIZE));
const countryPage = ref(1);
let scrollableEl: HTMLElement | null = null;
let scrollListener: any = null;

const emailAdd = ref<string[]>(['']);
const phoneNumber = ref([
    {
        country_code: '1',
        phone_number: '',
    },
]);

const selectedTags = ref<{ name: string; code: string }[]>([]);
const selectedTag = ref(null);
const popover = ref();

function onTagInputEnter(event: KeyboardEvent) {
    const inputValue = (event.target as HTMLInputElement).value.trim();
    if (!inputValue) return;
    if (selectedTags.value.some(tag => tag.name.toLowerCase() === inputValue.toLowerCase())) {
        selectedTag.value = null;
        (event.target as HTMLInputElement).value = '';
        hidePopover();
        return;
    }
    let tag = tags.value.find(t => t.name.toLowerCase() === inputValue.toLowerCase());
    if (!tag) {
        tag = { name: inputValue, code: inputValue.toLowerCase().replace(/\s+/g, '-') };
    }
    selectedTags.value.push(tag);
    selectedTag.value = null;
    (event.target as HTMLInputElement).value = '';
    hidePopover();
}

const tags = ref([
    { name: 'Friends', code: 'friend' },
    { name: 'Gamers', code: 'gamer' },
    { name: 'Family', code: 'family' },
    { name: 'Coworkers', code: 'coworker' },
]);

const addEmail = () => {
    // Only add new email field if the last one is filled
    if (emailAdd.value[emailAdd.value.length - 1] && emailAdd.value[emailAdd.value.length - 1].trim().length > 0) {
        emailAdd.value.push('');
    }
};

const removeEmail = (index: number) => {
    emailAdd.value.splice(index, 1);
};

const addphoneNumber = () => {
    // Only add new phone field if the last one is filled
    if ( !phoneNumber.value[phoneNumber.value.length - 1]) {
        phoneNumber.value.push({
            country_code: '1',
            phone_number: '',
        });
        return;
    }
    if (phoneNumber.value[phoneNumber.value.length - 1] && phoneNumber.value[phoneNumber.value.length - 1].phone_number.trim().length > 0) {
        phoneNumber.value.push({
            country_code: '1',
            phone_number: '',
        });
    }
};

const removephoneNumber = (index: number) => {
    phoneNumber.value.splice(index, 1);
};

const removeTag = (label: { name: string }) => {
    const index = selectedTags.value.findIndex((l) => l.name === label.name);
    if (index !== -1) {
        selectedTags.value.splice(index, 1);
    }
}

// Email validation function
const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

//computed, can add contact only if name is provided and at least one email is provided
const canAddContact = computed(() => {
    return store.searchTerm.length > 0 &&
           emailAdd.value[0] &&
           emailAdd.value[0].trim().length > 0 &&
           isValidEmail(emailAdd.value[0].trim());
});

//computed, can add more email fields only if the last one is filled and valid
const canAddMoreEmail = computed(() => {
    const lastEmail = emailAdd.value[emailAdd.value.length - 1];
    return lastEmail && lastEmail.trim().length > 0 && isValidEmail(lastEmail.trim());
});

//computed, can add more phone fields only if the last one is filled
const canAddMorePhone = computed(() => {
    const lastPhone = phoneNumber.value[phoneNumber.value.length - 1];
    if ( !lastPhone) {
        return true;
    }
    return lastPhone && lastPhone.phone_number && lastPhone.phone_number.trim().length > 0;
});

const { showSuccess, showError, showWarning } = useGlobalToast();
const isAddingContact = ref(false);
const store = useContactsStore();
const vault_store = useVaultStore();

// Watch for modal data changes and prefill relative information
watch(() => props.modalData?.contact, (relativeData) => {
    if (relativeData && typeof relativeData === 'object') {
        // Prefill display name with relative's name
        const displayName = `${relativeData.first_name || ''} ${relativeData.last_name || ''}`.trim();
        store.searchTerm = displayName;
        
        // Optionally prefill age as a tag if it exists
        if (relativeData.age) {
            selectedTags.value.push({ 
                name: `Age: ${relativeData.age}`, 
                code: `age-${relativeData.age}` 
            });
        }
        
        // Add "Relative" tag by default
        selectedTags.value.push({ 
            name: 'Relative', 
            code: 'relative' 
        });
    }
}, { immediate: true });

//handle add contact
async function addContact() {
    // Validate required fields
    if (!store.searchTerm.trim()) {
        showError('Error', 'Display name is required');
        return;
    }

    if (!emailAdd.value[0] || !emailAdd.value[0].trim()) {
        showError('Error', 'At least one email address is required');
        return;
    }

    if (!isValidEmail(emailAdd.value[0].trim())) {
        showError('Error', 'Please enter a valid email address');
        return;
    }

    // Validate all other emails if they exist
    for (let i = 1; i < emailAdd.value.length; i++) {
        if (emailAdd.value[i] && emailAdd.value[i].trim() && !isValidEmail(emailAdd.value[i].trim())) {
            showError('Error', `Email address at position ${i + 1} is not valid`);
            return;
        }
    }

    isAddingContact.value = true;

    //prepare data
    const postData = {
        name: store.searchTerm.trim(),
        emails: emailAdd.value.filter(email => email && email.trim().length > 0 && isValidEmail(email.trim())), // Filter out empty and invalid emails
        phone_numbers: phoneNumber.value.filter(phone => phone.phone_number && phone.phone_number.trim().length > 0), // Filter out empty phone numbers
        tags: selectedTags.value.map(tag => tag.name),
        blocked: false,
    };

    const success = await store.createContact(postData);

    if (success) {
        // If this came from an exposure, suppress the original exposure
        if (props.modalData?.fromExposure && props.modalData?.exposureData) {
            try {
                const exposureData = props.modalData.exposureData;
                const exposureType = exposureData.type || 'relative';
                await vault_store.updateExposure(true, exposureType, exposureData.value);
                await vault_store.updatePotentialExposures(exposureType, exposureData.value, true);
                
                // Refresh the potential exposures to update the UI
                await vault_store.fetchPotentialExposures();
            } catch (error) {
                console.error('Error suppressing exposure:', error);
                // Don't fail the contact creation if exposure suppression fails
            }
        }

        //close dialog
        store.searchTerm = '';
        isAddingContact.value = false;
        close();
    } else {
        isAddingContact.value = false;
    }
}

function loadMoreCountriesIfNeeded() {
    if (!scrollableEl) return;
    if (scrollableEl.scrollTop + scrollableEl.clientHeight >= scrollableEl.scrollHeight - 10) {
        const nextPage = countryPage.value + 1;
        const nextOptions = countryOptions.slice(0, nextPage * PAGE_SIZE);
        if (nextOptions.length > visibleCountryOptions.value.length) {
            visibleCountryOptions.value = nextOptions;
            countryPage.value = nextPage;
        }
    }
}

function attachScrollListener() {
    const panel = document.querySelector('.country-select-panel');
    if (!panel) {
        return;
    }

    const scrollable = panel.querySelector('.select-list-container') as HTMLElement;
    if (scrollable) {
        scrollableEl = scrollable;
        scrollListener = () => loadMoreCountriesIfNeeded();
        scrollableEl.addEventListener('scroll', scrollListener, { passive: true });
    }
}

function detachScrollListener() {
    if (scrollableEl && scrollListener) {
        scrollableEl.removeEventListener('scroll', scrollListener);
        scrollableEl = null;
        scrollListener = null;
    }
}

function onCountryDropdownShow() {
    setTimeout(() => {
        attachScrollListener();
    }, 0);
}

function onCountryDropdownHide() {
    detachScrollListener();
}

const onEnter = (e: KeyboardEvent) => {
    if (canAddContact.value && !isAddingContact.value) {
        addContact();
    }
};

const togglePopover = (event: any) => {
  popover.value.toggle(event);

  setTimeout(() => {
    const inputContainer = document.querySelector('.input-container');
    const popoverEl = document.querySelector('.tags-container');
    if (inputContainer && popoverEl) {
        //@ts-ignore
      popoverEl.style.width = `${inputContainer.offsetWidth}px`;
    }
  }, 0);
};

const hidePopover = () => {
    popover.value.hide();
};

function handleTag(tag: any) {
    selectedTags.value.push(tag);
    hidePopover();
}
onUnmounted(() => {
    detachScrollListener();
});
</script>

<style lang="scss" scoped>
.section-container {
    @apply flex flex-col items-start gap-1 w-full;
}
.section-tag-container {
    @apply flex flex-col items-start gap-2.5 w-full;
}
.input-container {
    @apply flex items-center w-full h-10 border border-zinc-300 rounded bg-white;
}
.delete-item-btn {
    @apply px-3 text-gray-500 hover:text-red-500 border-l border-zinc-300 h-full flex items-center cursor-pointer;
}
.input-field {
    @apply flex-1 py-2 px-3 focus:outline-none border border-zinc-300 border-x-white;
}
.add-another-btn-container {
    @apply flex justify-start items-center gap-1.5 cursor-pointer;

    .add-another-btn {
        @apply text-blue-600 font-inter text-sm font-semibold leading-5;
    }
}
.section-wrapper {
    @apply flex flex-col items-start gap-1.5 w-full;
}
.add-contact-container {
    @apply flex flex-col items-start gap-4 px-6 self-stretch overflow-y-auto;

    &::-webkit-scrollbar {
        @apply w-2 block;
    }

    &::-webkit-scrollbar-track {
        @apply rounded-lg bg-gray-100;
    }

    &::-webkit-scrollbar-thumb {
         @apply rounded-lg bg-gray-200;
    }
}
.add-contact-label {
    @apply text-gray-700 font-inter text-sm font-medium leading-5;
}
.validation-message {
    @apply mt-1;
}
.custom-button {
    @apply text-gray-700 text-center font-inter text-xs font-medium flex items-center gap-0.5 px-0.5 py-0.5 pl-2 rounded-2xl border border-gray-200 bg-gray-50 ;

    svg {
        @apply flex flex-col items-start;
    }
}
.add-contact-footer {
    @apply flex flex-col justify-center items-end self-stretch pt-8;

    .footer-actions {
        @apply flex justify-end items-center gap-3 flex-1 px-6 pb-6 w-full;
    }

}
.select-label{
    @apply whitespace-nowrap
}
.tags-container {
    @apply flex flex-col items-start rounded-lg border border-zinc-200 bg-white mt-1;

    .tag-items {
        @apply flex flex-col items-start self-stretch gap-0.5 py-1.5;

        .tag-input {
            @apply flex flex-col items-end self-stretch px-1.5 py-0;

            span {
                @apply cursor-pointer w-full items-end p-2 text-zinc-700 text-left font-inter text-sm font-semibold leading-5;

                &:hover {
                    @apply bg-blue-10;
                }
            }
        }
    }
}
</style>
